'use strict'

import React from 'react';

export default class Status extends React.Component {
  imageLink(status) {
    var prefix=this.props.prefix!==undefined ? this.props.prefix : "/"
    switch (status) {
      case "green" : return prefix+"images/greenlight.png";
      case "yellow": return prefix+"images/yellowlight.png";
      case "red": return prefix+"images/redlight.png";
      default: return undefined;
    }
  }

  render() {
    return (
      <img style={this.props.style} src={this.imageLink(this.props.value)}/>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/Status.jsx